// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 .navbar {    padding: 10px 0px;
    transition: 0.5s all ease;
  background:white !important;
  
}
#header.active {
    box-shadow: 0 0 10px rgba(0,0,0,0.4);   
}

.navbar .navbar-brand img {
    vertical-align: middle;
    margin-right: 1em;
    max-width:160px;
    left: 0;
    position: relative;
}
.cranfield-logo-height
{
    height: 60px !important;
    width: 68px !important;
}
.padding-3
{
    padding-top: 1rem;
    padding-bottom:1rem;
}
.license
{
    top: 0;
    border: 1px solid !important;
}
.navbar .navbar-toggler {
    border: none;
}

.navbar span.navbar-toggler-icon {
    /* background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0, 0.9)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E"); */
    background-image: url(/assets/images/hamburger.png);
}

.navbar span.navbar-toggler-icon::before {
    outline: none;
}

.nav-link{
    color: black;
    padding: 0.25rem 1rem;
    font-size: 15px;
}
.navbar .navbar-toggler:focus {
    outline: none;
}

.navbar-nav {
    text-align: center;
    margin-top: 0; /* For Safari 3.1 to 6.0 */
    transition: 0.5s all ease;
}

.navbar-nav .nav-item {
    margin-right: 0;
    margin-top: 0;

  margin-left:10px;
}


.offcanvas-active{
    transition: 5s all ease !important;
}
.logo{
    margin-top: 0px;
    padding-left: 2rem;
    padding-right: 2rem;
}
.btn-close{display: none;}
.navbar-collapse{
    flex-grow: 0;
}

li.nav-item {
    line-height: 36px;
}
.register{
    color: #fff;
    padding: 0 1rem;
    background: #0070C0;
    border: none;
    border-radius: 10px ;
}
.book{
    color: #000;
    padding: 0 1rem;
    background: #10C7FC;
    border: none;
    border-radius: 10px ;
    font-weight: 600;
}
.web{
    display: flex;
}
.mob{
    display: none;
}
@media screen and (max-width: 600px) {
    .mob{
        display: flex;
    }
    .navbar{
        padding: 14px 0px 0px 0px;
    }
    .mob .nav-link{
        padding: 1rem;
        color: white;
        font-family: 'Montserrat';
        font-weight: 700;
        border-bottom: 1px solid white;
    }
    .web{
        display: none;
    }
    .navbar-nav {
        margin-top: 60px;
    }
    .navbar-toggler-icon {position: relative;}
    .offcanvas-header{ display:block; }
    .navbar-collapse {
      position: fixed;
      top:0; 
      bottom: 0;
      left: 90%;
      z-index: 100;
      width: 100%;
      padding-right: .5rem;
      padding-left: 1rem;
      overflow-y: auto;
      visibility: hidden;
      background:#47bce7 !important;
      transition: visibility .2s ease-in-out;
    }
    .navbar-collapse.show {
      visibility: visible;
      position: fixed;
      transform: translateX(-100%);
    }
    .navbar .navbar-brand img {
      left: 52%;
       
    }
    .btn-close{display: block;}
    .logo{
        margin-top: -45px;
        padding-left: 1rem;
        padding-right: 1rem;
    }
  }
  @media only screen and (max-width: 500px)
  {
    .navbar .navbar-brand img {
        margin-right: 0em;
        max-width: 80px;
        left: 15%;
    }
    .padding-3
    {
        padding-top: .5rem;
        padding-bottom:.5rem;
    }
    .mainpadding
    {
        padding-top: .5rem;
        padding-bottom:.5rem;
    }
    .default-size img
    {
        max-width: 110px !important;
        left: 30% !important;
    }
  }
  @media only screen and (max-width: 375px){
    .navbar .navbar-brand img {
        
        left: 20%;
        max-width: 70px;
      }
     
  }
  @media only screen and (max-width: 340px){
   .navbar .navbar-brand img {
        
        left: 25px;
        max-width: 75px;
      }
      .nav-link {
        font-size: 10px;
    }
  }
  .bg-mediumblue {
    background-color: #10C7FC;
}`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.css"],"names":[],"mappings":";CACC,aAAa,iBAAiB;IAE3B,yBAAyB;EAC3B,2BAA2B;;AAE7B;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,OAAO;IACP,kBAAkB;AACtB;AACA;;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;IAEI,MAAM;IACN,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,yQAAyQ;IACzQ,mDAAmD;AACvD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa,EACsB,0BAA0B;IAC7D,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;;EAEf,gBAAgB;AAClB;;;AAGA;IACI,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA,WAAW,aAAa,CAAC;AACzB;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,gBAAgB;QAChB,8BAA8B;IAClC;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA,sBAAsB,kBAAkB,CAAC;IACzC,mBAAmB,aAAa,EAAE;IAClC;MACE,eAAe;MACf,KAAK;MACL,SAAS;MACT,SAAS;MACT,YAAY;MACZ,WAAW;MACX,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,6BAA6B;MAC7B,sCAAyE;IAC3E;IACA;MACE,mBAAmB;MACnB,eAAe;MACf,4BAA4B;IAC9B;IACA;MACE,SAAS;;IAEX;IACA,WAAW,cAAc,CAAC;IAC1B;QACI,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;EACF;EACA;;IAEE;QACI,iBAAiB;QACjB,eAAe;QACf,SAAS;IACb;IACA;;QAEI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;;QAEI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;;QAEI,2BAA2B;QAC3B,oBAAoB;IACxB;EACF;EACA;IACE;;QAEI,SAAS;QACT,eAAe;MACjB;;EAEJ;EACA;GACC;;QAEK,UAAU;QACV,eAAe;MACjB;MACA;QACE,eAAe;IACnB;EACF;EACA;IACE,yBAAyB;AAC7B","sourcesContent":["\n .navbar {    padding: 10px 0px;\n    -webkit-transition: 0.5s all ease;\n    transition: 0.5s all ease;\n  background:white !important;\n  \n}\n#header.active {\n    box-shadow: 0 0 10px rgba(0,0,0,0.4);   \n}\n\n.navbar .navbar-brand img {\n    vertical-align: middle;\n    margin-right: 1em;\n    max-width:160px;\n    left: 0;\n    position: relative;\n}\n.cranfield-logo-height\n{\n    height: 60px !important;\n    width: 68px !important;\n}\n.padding-3\n{\n    padding-top: 1rem;\n    padding-bottom:1rem;\n}\n.license\n{\n    top: 0;\n    border: 1px solid !important;\n}\n.navbar .navbar-toggler {\n    border: none;\n}\n\n.navbar span.navbar-toggler-icon {\n    /* background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0, 0.9)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\"); */\n    background-image: url(/assets/images/hamburger.png);\n}\n\n.navbar span.navbar-toggler-icon::before {\n    outline: none;\n}\n\n.nav-link{\n    color: black;\n    padding: 0.25rem 1rem;\n    font-size: 15px;\n}\n.navbar .navbar-toggler:focus {\n    outline: none;\n}\n\n.navbar-nav {\n    text-align: center;\n    margin-top: 0;\n    -webkit-transition: 0.5s all ease; /* For Safari 3.1 to 6.0 */\n    transition: 0.5s all ease;\n}\n\n.navbar-nav .nav-item {\n    margin-right: 0;\n    margin-top: 0;\n\n  margin-left:10px;\n}\n\n\n.offcanvas-active{\n    transition: 5s all ease !important;\n}\n.logo{\n    margin-top: 0px;\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n.btn-close{display: none;}\n.navbar-collapse{\n    flex-grow: 0;\n}\n\nli.nav-item {\n    line-height: 36px;\n}\n.register{\n    color: #fff;\n    padding: 0 1rem;\n    background: #0070C0;\n    border: none;\n    border-radius: 10px ;\n}\n.book{\n    color: #000;\n    padding: 0 1rem;\n    background: #10C7FC;\n    border: none;\n    border-radius: 10px ;\n    font-weight: 600;\n}\n.web{\n    display: flex;\n}\n.mob{\n    display: none;\n}\n@media screen and (max-width: 600px) {\n    .mob{\n        display: flex;\n    }\n    .navbar{\n        padding: 14px 0px 0px 0px;\n    }\n    .mob .nav-link{\n        padding: 1rem;\n        color: white;\n        font-family: 'Montserrat';\n        font-weight: 700;\n        border-bottom: 1px solid white;\n    }\n    .web{\n        display: none;\n    }\n    .navbar-nav {\n        margin-top: 60px;\n    }\n    .navbar-toggler-icon {position: relative;}\n    .offcanvas-header{ display:block; }\n    .navbar-collapse {\n      position: fixed;\n      top:0; \n      bottom: 0;\n      left: 90%;\n      z-index: 100;\n      width: 100%;\n      padding-right: .5rem;\n      padding-left: 1rem;\n      overflow-y: auto;\n      visibility: hidden;\n      background:#47bce7 !important;\n      transition: visibility .2s ease-in-out, -webkit-transform .2s ease-in-out;\n    }\n    .navbar-collapse.show {\n      visibility: visible;\n      position: fixed;\n      transform: translateX(-100%);\n    }\n    .navbar .navbar-brand img {\n      left: 52%;\n       \n    }\n    .btn-close{display: block;}\n    .logo{\n        margin-top: -45px;\n        padding-left: 1rem;\n        padding-right: 1rem;\n    }\n  }\n  @media only screen and (max-width: 500px)\n  {\n    .navbar .navbar-brand img {\n        margin-right: 0em;\n        max-width: 80px;\n        left: 15%;\n    }\n    .padding-3\n    {\n        padding-top: .5rem;\n        padding-bottom:.5rem;\n    }\n    .mainpadding\n    {\n        padding-top: .5rem;\n        padding-bottom:.5rem;\n    }\n    .default-size img\n    {\n        max-width: 110px !important;\n        left: 30% !important;\n    }\n  }\n  @media only screen and (max-width: 375px){\n    .navbar .navbar-brand img {\n        \n        left: 20%;\n        max-width: 70px;\n      }\n     \n  }\n  @media only screen and (max-width: 340px){\n   .navbar .navbar-brand img {\n        \n        left: 25px;\n        max-width: 75px;\n      }\n      .nav-link {\n        font-size: 10px;\n    }\n  }\n  .bg-mediumblue {\n    background-color: #10C7FC;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
